import { Mapper } from '../base-mapper';
import { ActionPlanUpdateComments, ActionPlanUpdateCommentsDomain } from '../../domain';
import { ActionPlanUpdateCommentsDTO, ActionPlanUpdateCommentsItemDTO } from '../../dto';

export class ActionPlanUpdateCommentsMapper implements Mapper<ActionPlanUpdateCommentsDomain> {
	private readonly response: ActionPlanUpdateCommentsDTO;

	constructor(response: ActionPlanUpdateCommentsDTO) {
		this.response = {
			status: response.status,
			message: response.message,
			data: Array.isArray(response.data) ? response.data : []
		};
	}

	private mapActionPlanItem(item: ActionPlanUpdateCommentsItemDTO): ActionPlanUpdateComments {
		return new ActionPlanUpdateComments({
			id: item.id
		});
	}

	toDomain(): ActionPlanUpdateCommentsDomain {
		return {
			status: this.response.message,
			message: this.response.message,
			data: this.response.data.map((item) => this.mapActionPlanItem(item))
		};
	}
}
